import React from "react"
import { Container } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'
import { motion } from "framer-motion";

const About = () =>
{
    return(
      <div>
            <Container>
                <h1>About</h1>
            <p>I am a former Computer Science and Software Engineering student, with a domain application of information assurance, at the University of Texas at Dallas. I work for Fidelity Investments as an associate software engineer. I go back for my masters degree here in the spring. Afterwards I plan on obtaining my doctorate degree. </p>
                </Container>
        </div>
    )
}

export default About;
